import LeadInfo from './LeadInfo.component';

export default LeadInfo;
